import React from 'react';
import { Avatar, Circle, Pressable, View, useTheme } from 'native-base';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import IconShield from './IconShield';
import { faUser } from '@fortawesome/pro-regular-svg-icons';
const UserAvatar = ({
  onPress,
  marginRight,
  userAvatar,
  reply,
  moderator
}) => {
  const {
    colors
  } = useTheme();
  const basicUserAvatar = /*#__PURE__*/React.createElement(Circle, {
    size: '36px',
    bg: 'secondary.400'
  }, userAvatar ? /*#__PURE__*/React.createElement(Avatar, {
    source: {
      uri: userAvatar
    },
    size: 9
  }) : /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: faUser,
    color: colors.createEditButton.avatar.icon,
    size: 6
  }));
  const userAvatarImage = moderator || reply !== null && reply !== void 0 && reply.moderator || reply !== null && reply !== void 0 && reply.group_moderator ? /*#__PURE__*/React.createElement(View, {
    style: {
      position: 'relative',
      width: 50,
      height: 50
    }
  }, /*#__PURE__*/React.createElement(Circle, {
    size: 10,
    borderColor: colors.createEditButton.avatar.highlight,
    borderWidth: 2
  }, basicUserAvatar), /*#__PURE__*/React.createElement(IconShield, {
    bottom: 6,
    right: 10
  })) : basicUserAvatar;
  return /*#__PURE__*/React.createElement(Pressable, {
    onPress: onPress,
    style: {
      marginRight
    }
  }, userAvatarImage);
};
export default UserAvatar;
//# sourceMappingURL=UserAvatar.js.map